(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('FixationManagement',FixationManagement);

    FixationManagement.$inject = ['$resource'];

    function FixationManagement($resource) {
        var resourceUrl = "api/management/fixation/:id";

        return $resource(resourceUrl,{},{
            'query': {method:'GET',isArray:true}
        });
    }
})();
